import { render, staticRenderFns } from "./THGTag.vue?vue&type=template&id=ae5de750"
import script from "./THGTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGTag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports